import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const longArrowDown: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.75-2c.113 0 .191.055.234.156a.24.24 0 0 1-.046.266l-2.735 3a.25.25 0 0 1-.172.078.26.26 0 0 1-.187-.078l-2.781-3Q-.044-1.701.03-1.86.091-2 .25-2H2v-9.75q0-.106.063-.172A.26.26 0 0 1 2.25-12h1.5q.106 0 .172.078.076.066.078.172V-2zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "13.5",
    width: "6.005",
  }
};

export const longArrowUp: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.984-8.156Q5.903-8 5.75-8H4v9.75q0 .106-.078.172A.22.22 0 0 1 3.75 2h-1.5a.26.26 0 0 1-.187-.078A.23.23 0 0 1 2 1.75V-8H.25a.25.25 0 0 1-.234-.14.27.27 0 0 1 .047-.282l2.734-3a.26.26 0 0 1 .187-.078.27.27 0 0 1 .188.078l2.766 3q.105.127.046.266m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0.005 11.5)"
    />
  ),
  svgProps: {
    height: "13.5",
    width: "6.011",
  }
};
